exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".loading-component{margin:15px 0;text-align:center}.fa-spinner{animation:spin 2s infinite linear;-webkit-animation:spin 2s infinite linear}@keyframes spin{0%{-webkit-transform:rotate(0deg)}to{-webkit-transform:rotate(1turn)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader?outputStyle=expanded!./src/styles/Loading.scss
// module id = 643
// module chunks = 0